/** Route der Richtlinien-Werkstatt. */
export const GUIDELINES_PATH = "/guidelines";

/** „GEFMA190.2023-06.pdf" → „GEFMA 190 (Ausgabe 2023-06)"; andere Titel bleiben, nur ohne Dateiendung. */
export const displayTitle = (title: string) => {
  const base = title.replace(/\.(pdf|docx?)$/i, "");
  const m = /^([A-Za-zÄÖÜ]+)\s*(\d+(?:-\d+)?)[.\s]+(\d{4}-\d{2})$/.exec(base);
  return m ? `${m[1]} ${m[2]} (Ausgabe ${m[3]})` : base;
};

/** Anhänge tragen die Nummer ohne das Wort („A“, Art `app`); gezeigt wird „Anhang A“ wie im Export. */
export const displayNumber = (s: { number: string; kind?: string | null }) => (s.kind === "app" && s.number ? `Anhang ${s.number}` : s.number);

/**
 * Öffentliche Adresse der Werkstatt für Verweise, die gespeichert werden (Begriff aus einer anderen
 * Richtlinie) — dieselbe wie in den E-Mails des Servers (notify.ts), nicht die des Browsers: die Daten
 * sind zwischen Entwicklung und Betrieb geteilt.
 */
export const PUBLIC_GUIDELINES_URL = "https://www.the-real-insight.ai/guidelines";
